<template>
  <div class="policy-card__container">
    <div class="policy-card__content">
      <div class="policy-card__section">
        <div class="policy-card__field-row">
          <InfoRow
            class="policy-card__field"
            label="Тип тварини"
            :value="petTypeLabel"
          />
          <InfoRow
            class="policy-card__field"
            label="Порода"
            :value="petBreed"
          />
        </div>

        <div class="policy-card__field-row">
          <InfoRow
            class="policy-card__field"
            label="Стать"
            :value="petSexLabel"
          />
          <InfoRow
            class="policy-card__field"
            label="Клічка"
            :value="petAlias"
          />
        </div>

        <div class="policy-card__field-row">
          <InfoRow
            class="policy-card__field"
            label="Дата народження"
            :value="petBirthDate"
          />
          <InfoRow
            class="policy-card__field"
            label="Ціна"
            :value="formatNumber(price, { suffix: ' грн'})"
          />
        </div>
      </div>

      <Divider type="horizontal" />

      <div class="policy-card__section">
        <div class="policy-card__field-row">
          <InfoRow
            class="policy-card__field"
            label="Повне імʼя"
            :value="fullName"
          />
          <InfoRow
            class="policy-card__field"
            label="Дата народження"
            :value="birthdate"
          />
        </div>

        <div class="policy-card__field-row">
          <InfoRow
            class="policy-card__field"
            label="Email, Телефон"
            :value="`${email}, ${phone}`"
          />
          <InfoRow
            class="policy-card__field"
            label="ІПН"
            :value="taxNumber"
          />
        </div>

        <div class="policy-card__field-row">
          <InfoRow
            class="policy-card__field"
            label="Адреса"
            :value="address"
          />
          <InfoRow
            class="policy-card__field"
            label="Прописка"
            :value="city"
          />
        </div>
      </div>

      <Divider type="horizontal" />

      <div class="policy-card__section">
        <div class="policy-card__field-row">
          <InfoRow
            class="policy-card__field"
            label="Серія і номер"
            :value="documentNumber"
          />
          <InfoRow
            class="policy-card__field"
            label="Видано"
            :value="documentIssuedBy"
          />
        </div>

        <div class="policy-card__field-row">
          <InfoRow
            class="policy-card__field"
            label="Дата видачі"
            :value="documentDate"
          />
        </div>
      </div>

      <Divider type="horizontal" />

      <div class="policy-card__section">
        <div class="policy-card__field-row">
          <InfoRow
            class="policy-card__field"
            label="Період"
            :value="period"
          />
        </div>

        <div class="policy-card__field-row">
          <InfoRow
            class="policy-card__field"
            label="Дата початку"
          >
            <LabeledDateInput
              class="policy-card__date-input"
              label=""
              type="input"
              :is-disabled="isStartDateDisabled"
              :disabled-past-dates="true"
              :min-date="getMinDate"
              v-model="selectedStartDate"
              format="DD.MM.YYYY"
              @change="$emit('dateChange', $event)"
            />
          </InfoRow>
          <InfoRow
            class="policy-card__field"
            label="Дата закінчення"
            :value="endDate"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { default as InfoRow } from './info-row';
import { petSexLabels, petTypeLabels } from '@/entities/insurance/config';
import { FRANCHISE_DAYS } from '@/features/pets-calculator/config';
import { NumberFormatter } from '@/shared/lib/number';
import { Divider } from '@/shared/ui/divider';
import { LabeledDateInput } from '@/shared/ui/form';

const { formatNumber } = NumberFormatter();

export default {
  props: {
    petType: {
      type: [String, Number],
      default: null,
    },
    petBreed: {
      type: String,
      default: '',
    },
    petSex: {
      type: [String, Number],
      default: null,
    },
    petAlias: {
      type: String,
      default: '',
    },
    petBirthDate: {
      type: [String, Date],
      default: '',
    },
    price: {
      type: Number,
      required: true,
    },
    fullName: {
      type: String,
      required: true,
    },
    birthdate: {
      type: [String, Date],
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
    phone: {
      type: String,
      required: true,
    },
    taxNumber: {
      type: String,
      required: true,
    },
    city: {
      type: String,
      required: true,
    },
    address: {
      type: String,
      required: true,
    },
    documentNumber: {
      type: String,
      required: true,
    },
    documentIssuedBy: {
      type: String,
      required: true,
    },
    documentDate: {
      type: [String, Date],
      required: true,
    },
    period: {
      type: String,
      required: true,
    },
    startDate: {
      type: [String, Date],
      required: true,
    },
    endDate: {
      type: [String, Date],
      required: true,
    },
    isStartDateDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedStartDate: null,
    };
  },
  computed: {
    petTypeLabel() {
      return petTypeLabels[this.petType] || this.petType || '';
    },
    petSexLabel() {
      return petSexLabels[this.petSex] || this.petSex || '';
    },
    getMinDate() {
      return moment().add(FRANCHISE_DAYS, 'days').toDate();
    },
  },
  watch: {
    startDate: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.selectedStartDate = newValue;
        }
      },
    },
  },
  components: { InfoRow, Divider, LabeledDateInput },
  methods: {
    formatNumber,
  },
};
</script>

<style scoped lang="scss">
.policy-card {
  &__container {
    border: 1px solid #CBD5E1;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0px 1px 2px 0px #0000000F, 0px 1px 3px 0px #0000001A;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  &__field-row {
    display: flex;
    gap: 24px;
    margin-bottom: 16px;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 12px;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__field {
    flex: 1;
  }

  &__date-input {
    flex: 1;
  }
}
</style>
